module.exports = __webpack_public_path__ + "media/metronic/_theme/media/logos/logo-light-sm-19a9e5c354f2cb8ef41bbb23d4ca85aa.png";